import { BiEnvelope, BiMap } from "react-icons/bi";

export const ContactSection = ({
                                   tagline = "",
                                   heading = "Contact Us",
                                   description = "If you have any questions don't be afraid to reach out!",
                                   contacts = [
                                       {
                                           icon: <BiEnvelope className="text-red-500 w-14 h-14" />,
                                           title: "Email",
                                           description:
                                               "For registration & general inquiries contact us by email for fastest response",
                                           link: {
                                               label: "info@federationskatingclub.ca",
                                               url: "mailto:info@federationskatingclub.ca",
                                           },
                                       },
                                       {
                                           icon: <BiMap className="text-red-500 w-14 h-14" />,
                                           title: "Mailing Address",
                                           description: "Our official mailing address:",
                                           link: {
                                               label: `PO Box 25526\nRPO West Drive Thru\nEdmonton, Alberta T5T 7E7`,
                                               url: "#",
                                           },
                                       },
                                   ],
                               }) => {
    return (
        <section className="px-[5%] py-16 md:py-24 lg:py-28 bg-gray-50">
            <div className="container">
                {/* Header */}
                <div className="mb-16 text-center">
                    {tagline && (
                        <p className="mb-3 text-sm font-semibold uppercase text-red-500 tracking-widest">
                            {tagline}
                        </p>
                    )}
                    <h2 className="mb-5 text-4xl font-extrabold text-gray-900 md:mb-6 md:text-6xl lg:text-7xl">
                        {heading}
                    </h2>
                    <p className="max-w-2xl mx-auto text-lg text-gray-600">{description}</p>
                </div>

                {/* Contact Cards */}
                <div className="grid grid-cols-1 gap-x-12 gap-y-12 md:grid-cols-2 md:gap-y-16">
                    {contacts.map((contact, index) => (
                        <div
                            key={index}
                            className="flex flex-col items-center p-8 bg-white rounded-xl shadow-md hover:shadow-xl transition-shadow duration-300 text-center"
                        >
                            <div className="flex items-center justify-center mb-5">{contact.icon}</div>
                            <h3 className="mb-3 text-2xl font-bold text-gray-900 md:text-3xl">
                                {contact.title}
                            </h3>
                            <p className="mb-4 text-gray-600">{contact.description}</p>
                            <a
                                className="text-red-600 underline break-words whitespace-pre-line hover:text-red-700"
                                href={contact.link.url}
                            >
                                {contact.link.label}
                            </a>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};
